/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var flickityInstance;

function extend() {
  var extended = {};
  var i = 0;

  // Merge the object into the extended object
  var merge = function merge(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        // If property is an object, merge properties
        if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
          extended[prop] = Form.extend(extended[prop], obj[prop]);
        } else {
          extended[prop] = obj[prop];
        }
      }
    }
  };

  // Loop through each object and conduct a merge
  for (; i < arguments.length; i++) {
    merge(arguments[i]);
  }

  return extended;
}

function serialize (form) {
  function stringKey(key, value) {
    var beginBracket = key.lastIndexOf('[');

    if (beginBracket === -1) {
      var _hash = {};
      _hash[key] = value;
      return _hash;
    }

    var newKey = key.substr(0, beginBracket);
    var newValue = {};

    newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

    return stringKey(newKey, newValue);
  }

  var hash = {};

  for (var i = 0, len = form.elements.length; i < len; i++) {
    var formElement = form.elements[i];

    if (formElement.name === '' || formElement.disabled) {
      continue;
    }

    if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
      var stringKeys = stringKey(formElement.name, formElement.value);
      hash = extend(hash, stringKeys);
    }
  }

  return hash;
}

formatMoney = function(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || '€{{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
  }

  var value = '';
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }

  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value).replace(',00', '');
  } else {
    return formatString.replace(placeholderRegex, value).replace('.00', '');
  }

};

// Find all the toggle buttons
var toggleNavigation = document.querySelectorAll('#header-navigation [toggle-nav]');
var siteHeader = document.querySelector('.site-header');
var openClass = 'is-open';

// Close all sub navigations
function closeAllSubNavigations() {
  toggleNavigation.forEach((item) => {
    var target = document.querySelector(`#${item.getAttribute('aria-controls')}`);
    target.classList.remove(openClass);
  });
  if (siteHeader.classList.contains('transparent-header')) {
    if (siteHeader.classList.contains('text-color-white')) {
      siteHeader.classList.remove('text-color-normal');
    }
    siteHeader.classList.remove('bg-white');
  }
}

// Toggle sub navigation
toggleNavigation.forEach((item) => {
  var target = document.querySelector(`#${item.getAttribute('aria-controls')}`);
  var action = item.getAttribute('aria-action');

  item.onclick = (element) => {
    // we are not in large mode
    element.preventDefault();
    if (action === 'open') {
      target.classList.add(openClass);
    }
    if (action === 'close') {
      target.classList.remove(openClass);
    }
  };
});

// Change Price when click quantity
function recalculateVariantPrices() {
  var prodPrice = $(".meter-price .ProductMeta__Price.Price--compareAt"),
      prodPriceContainer = $("#ComparePrice"),
      salePrice = $(".meter-price .ProductMeta__Price.Price"),
      salePriceContainer = $("#ProductPrice"),
      getProdPrice = parseFloat(prodPrice.text()).toFixed(2).replace(/\D/g,''),
      getSalePrice = parseFloat(salePrice.text()).toFixed(2).replace(/\D/g,''),
      quantity = $("#Quantity").val(),
      totalPrice = quantity * getProdPrice;
      if(getProdPrice) {
    prodPriceContainer.text(formatMoney(totalPrice));
  }
  var totalSalePrice = quantity * getSalePrice;
  salePriceContainer.text( formatMoney(totalSalePrice) );
};

function updateAvailability(variantId) {
  if(typeof productPage !== 'undefined') {
    variantId = variantId || productPage.selected_variant_id;
    var variantAvailability = productPage['availability'][variantId];
    var variantAvailabilityTranslation = productPage['availability']['translation'];
    var availabilityStatus = variantAvailability ? 'in_stock' : 'sold_out';
    var productAvailabilityContainer = document.querySelector('#product_availability');
    var indicatorHTML = '<div class="availability-status ' + availabilityStatus.replace('_', '-') + '"><div class="availability-indicator"></div><span>' + variantAvailabilityTranslation[availabilityStatus] + '</span></div>';
    productAvailabilityContainer.innerHTML = indicatorHTML;
  }
}

function updateProductFeatures(variantId) {
  if(typeof productPage !== 'undefined') {
    variantId = variantId || productPage.selected_variant_id;
    var variantFeatures = variantJson[variantId];

    if (!!variantFeatures.Material1) {
      var materialContainer = document.querySelector('#features-material');
      materialContainer.querySelector('h4').innerHTML = variantFeatures.translations.Material;
      materialContainer.querySelector('p').innerHTML = [variantFeatures.Material, variantFeatures.Material1, variantFeatures.Material2, variantFeatures.Material3, variantFeatures.Material4].filter(Boolean).join(', ');
    }
    if (!!variantFeatures.Size) {
      var sizeContainer = document.querySelector('#features-size');
      sizeContainer.querySelector('h4').innerHTML = variantFeatures.translations.Size;
      sizeContainer.querySelector('p').innerHTML = variantFeatures.Size;
    }
    if (!!variantFeatures.Report) {
      var reportContainer = document.querySelector('#features-report');
      reportContainer.querySelector('h4').innerHTML = variantFeatures.translations.Report;
      reportContainer.querySelector('p').innerHTML = variantFeatures.Report;
    }
    if (!!variantFeatures.Pcs) {
      var pcsContainer = document.querySelector('#features-pcs');
      pcsContainer.querySelector('h4').innerHTML = variantFeatures.translations.Pcs;
      pcsContainer.querySelector('p').innerHTML = variantFeatures.Pcs;
    }
    if (!!variantFeatures.Code) {
      var collectionContainer = document.querySelector('#features-code');
      collectionContainer.querySelector('h4').innerHTML = variantFeatures.translations.Code;
      collectionContainer.querySelector('p').innerHTML = variantFeatures.Code;
    }
    if (!!variantFeatures['EAN Code']) {
      var collectionContainer = document.querySelector('#features-ean-code');
      collectionContainer.querySelector('h4').innerHTML = variantFeatures.translations.EANCode;
      collectionContainer.querySelector('p').innerHTML = variantFeatures['EAN Code'];
    }
  }
}

function updateMeterPriceInMiniCart() {
  var $quantifySelector = $('.CartItem__QuantitySelector.meter-price');
  var $quantifyContainer = $quantifySelector.find('.qty-in-unit');
  var dataSpacing = $quantifyContainer.data('pattern-spacing');
  var quantity = $quantifySelector.find('.QuantitySelector__CurrentQuantity').val();
  var calculateUnits = dataSpacing * quantity;
}

document.addEventListener('theme:loading:end', function(event) {
  var sortPopoverElement = document.getElementById('collection-sort-popover');

  if(sortPopoverElement) {
    var selectedSortElement = sortPopoverElement.querySelector('.is-selected');
    var selectedSortText = selectedSortElement.innerHTML;
    document.querySelector('.current-sort').innerHTML = selectedSortText;
  }
});

function selectCell(index) {
  var shouldPause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (shouldPause) {
    flickityInstance.pausePlayer();
  }

  flickityInstance.select(index, false, !shouldAnimate);
}

function updateSlideshowImage(event) {
  var variant = event.detail.variant,
  previousVariant = event.detail.previousVariant;

  if (!variant || !variant['featured_media'] || previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variant['featured_media']['id']) {
  return;
  }

  for (var i = 0; i !== flickityInstance.cells.length; ++i) {
    var cellElement = flickityInstance.cells[i].element,
        mediaId = parseInt(cellElement.getAttribute('data-media-id'));

    if (mediaId === variant['featured_media']['id']) {
      selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
    }
  }
}

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  var QuantityContainer = $('#Quantity');

  if(!!flickityInstance) {
    updateSlideshowImage(event);
  }

  if(QuantityContainer) {
    $('#Quantity').val(1);
    var patternSpacing = $('#qty-in-unit').data('pattern-spacing');
    var quantity = $("#Quantity").val();
    var itemLength = patternSpacing * quantity;

    $("#qty-in-unit").text(itemLength.toFixed(2));
    recalculateVariantPrices();
  }

  if(typeof productPage !== 'undefined') {
    updateProductFeatures(variant.id);
    updateAvailability(variant.id);
  }
});

function openQuickShop(event) {
  var quickShopElement = document.querySelector('.quick-shop');

  if (event) {
    event.preventDefault();
  }
  quickShopElement.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('no-scroll');
  renderQuickShopView(event.target.dataset.productId);
}

function closeQuickShop(event) {
  var quickShopElement = document.querySelector('.quick-shop');

  if (event) {
    event.preventDefault();
  }
  quickShopElement.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('no-scroll');

  var quickShopDetail = document.querySelector('#quick-shop-content');
  let quickShopHTML = '';
  quickShopDetail.innerHTML = quickShopHTML;
}

document.documentElement.addEventListener('click', (event) => {
  const target = event.target;

  if (target.closest('[data-action="quick-add-to-cart"]')) {
    quickAddToCart(event);
  };
  
  if (target.closest('[data-action="instant-add-to-cart"]')) {
    quickAddToCart(event);
  };


  if (target.closest('[data-action="open-quick-shop"]')) {
    openQuickShop(event);
  };

  if (target.closest('[data-action="close-quickshop"]') || target.closest('.quickshop-overlay')) {
    closeQuickShop(event);
  };
});

function quickAddToCart(event) {
  event.stopPropagation();
  event.preventDefault(); // Prevent form to be submitted

  var addToCartButton = event.target;
  var variant_id = event.target.getAttribute('data-variant');

  // First, we switch the status of the button
  addToCartButton.setAttribute('disabled', 'disabled');
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  // Then we add the product in Ajax
  var formElement = {
    items: [
      {
        quantity: 1,
        id: variant_id,
      }
    ]
  };

  var jsonData = JSON.parse(document.querySelector('[data-product-json-'+ variant_id +']').innerHTML);
  var productData = jsonData['product'];
  var found = false;

  productData['variants'].forEach(function (variant) {
    if (variant['id'] == variant_id) {
      found = variant;
    }
  });

  fetch(window.routes.cartAddUrl + '.js', {
    body: JSON.stringify(formElement),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(function (response) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    if (response.ok) {
      addToCartButton.removeAttribute('disabled');
      // We simply trigger an event so the mini-cart can re-render
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: found || null,
          product: productData || null,
          quantity: 1
        }
      }));
    }
  });

  event.preventDefault();
}

function makeBuyButtonSticky() {
  if(typeof productPage !== 'undefined') {
    var buyButtonAnchor = document.querySelector('#ProductForm__BuyButtonAnchor');
    if(buyButtonAnchor) {
      var buyButtonContainer = document.querySelector('.ProductForm__BuyContainer');
      if(window.scrollY < (buyButtonAnchor.offsetTop) + parseInt(document.documentElement.style.getPropertyValue('--header-height'))) {
        buyButtonContainer.classList.remove('sticky-buy-cta');
      } else {
        buyButtonContainer.classList.add('sticky-buy-cta');
      }
    }
  }
}

function quantitySelectorWithUnit() {
  var patternSpacing = $('#qty-in-unit').data('pattern-spacing') || 1;
  
  $(".ProductForm__BuyCta .QuantitySelector__Button").on('click',function () {
    if( $('.ProductForm__BuyCta .QuantitySelector__CurrentQuantity').length ) {
      setTimeout(function(){ 
        var quantity = $("#Quantity").val();
        var itemLength = patternSpacing * quantity;
        
        $("#qty-in-unit").text(itemLength.toFixed(2));

        recalculateVariantPrices();
      }, 100);
    }
  });

  $(".ProductForm__BuyCta .QuantitySelector__CurrentQuantity").on('change',function () {
    var quantity = $("#Quantity").val();
    var itemLength = patternSpacing * quantity;
    $("#qty-in-unit").text(itemLength.toFixed(2));

    recalculateVariantPrices();
  });

  if( $('#qty-in-unit').length ) {
    var itemLength = $('#qty-in-unit').data('pattern-spacing') * $('#Quantity').val();
    jQuery("#qty-in-unit").text(itemLength.toFixed(2));
  }

  recalculateVariantPrices();
};

function addToCart(event) {
  event.stopPropagation();
  event.preventDefault(); // Prevent form to be submitted

  var addToCartButton = document.querySelector('.ProductForm__AddToCart');

  // First, we switch the status of the button
  addToCartButton.setAttribute('disabled', 'disabled');
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  // Then we add the product in Ajax
  var formElement = document.querySelector('form[action*="/cart/add"]');
  var selectedVariant = formElement.querySelector('[title="Variant"]').value;
  var selectedProduct = formElement.querySelector('[title="Variant"]').id.split('-').pop();

  var jsonData = JSON.parse(document.querySelector('[data-product-id-'+ selectedProduct +']').innerHTML);
  var productData = jsonData['product'];
  var found = false;

  productData['variants'].forEach(function (variant) {
    if (variant['id'] == selectedVariant) {
      found = variant;
    }
  });

  fetch(window.routes.cartAddUrl + '.js', {
    body: JSON.stringify(window.serialize(formElement)),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(function (response) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    if (response.ok) {
      addToCartButton.removeAttribute('disabled');
      // We simply trigger an event so the mini-cart can re-render
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: found || null,
          product: productData || null,
          quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
        }
      }));
      closeQuickShop(event);

    } else {
      response.json().then(function (content) {
        var errorMessageWrapper = document.querySelector('.ProductForm__ErrorMessage');
        var errorMessageElement = document.createElement('span');
        errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
        errorMessageElement.innerHTML = content['description'];
        addToCartButton.removeAttribute('disabled');
        errorMessageWrapper.insertAdjacentElement('afterend', errorMessageElement);
        setTimeout(function () {
          errorMessageElement.remove();
        }, 2500);
      });
    }
  });

  event.preventDefault();
}

function decreaseQuantity(event) {
  var target = event.target;
  target.nextElementSibling.value = Math.max(parseInt(target.nextElementSibling.value) - 1, 1);
}

function increaseQuantity(event) {
  var target = event.target;
  target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1;
}

function validateQuantity(event) {
  var target = event.target;
  target.value = Math.max(parseInt(target.value) || 1, 1);
}

var currentVariant;
var currentProduct;
var previousVariant;

function updateAddToCartButton(newVariant, element = document) {
  var addToCartButton = element.querySelector('.ProductForm__AddToCart');

  addToCartButton.classList.remove('Button--secondary');
  addToCartButton.classList.remove('Button--primary');

  if (!newVariant) {
    addToCartButton.setAttribute('disabled', 'disabled');
    addToCartButton.removeAttribute('data-action');
    addToCartButton.classList.add('Button--secondary');
    addToCartButton.innerHTML = window.languages.productFormUnavailable;
  } else {
    if (newVariant['available']) {
      addToCartButton.removeAttribute('disabled');
      addToCartButton.classList.add('Button--primary');
      addToCartButton.setAttribute('data-action', 'add-to-cart');
      addToCartButton.innerHTML = '<span>' + window.languages.productFormAddToCart + '</span>';
    } else {
      addToCartButton.setAttribute('disabled', 'disabled');
      addToCartButton.classList.add('Button--secondary');
      addToCartButton.removeAttribute('data-action');
      addToCartButton.innerHTML = window.languages.productFormSoldOut;
    }
  }
}

function updateUnitPrice(newVariant, element = document) {
  if (!newVariant) {
    return;
  }

  var unitPriceMeasurement = element.querySelector('.ProductMeta__UnitPriceMeasurement');

  if (!newVariant.hasOwnProperty('unit_price')) {
    unitPriceMeasurement.style.display = 'none';
    return;
  }

  unitPriceMeasurement.style.display = 'block';

  unitPriceMeasurement.querySelector('.UnitPriceMeasurement__Price').innerHTML = formatMoney(newVariant['unit_price'], window.theme.moneyFormat);
  unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceUnit').textContent = newVariant['unit_price_measurement']['reference_unit'];

  var unitPriceReferenceValue = unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceValue');
  unitPriceReferenceValue.textContent = newVariant['unit_price_measurement']['reference_value'];
  unitPriceReferenceValue.style.display = newVariant['unit_price_measurement']['reference_value'] === 1 ? 'none' : 'inline';
}

function updateProductPrices(newVariant, previousVariant, element = document) {
  var productMetaPrices = element.querySelectorAll('.ProductMeta__PriceList');

  for(var i = 0; i < productMetaPrices.length; i ++) {
    var productMetaPrice = productMetaPrices[i];
    if (!newVariant) {
      productMetaPrice.style.display = 'none';
    } else {
      if (previousVariant && previousVariant['price'] === newVariant['price'] && previousVariant['compare_at_price'] === newVariant['compare_at_price']) {
        return; // The price do not have changed so let's return to avoid changing the DOM for nothing
      }

      productMetaPrice.innerHTML = '';

      if (newVariant['compare_at_price'] > newVariant['price']) {
        productMetaPrice.innerHTML += '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>' + formatMoney(newVariant['price'], window.theme.moneyFormat) + '</span>';
        productMetaPrice.innerHTML += '<span class="ProductMeta__Price Price--compareAt Text--subdued u-h4" data-money-convertible>' + formatMoney(newVariant['compare_at_price'], window.theme.moneyFormat) + '</span>';
      } else {
        productMetaPrice.innerHTML += '<span class="ProductMeta__Price Price u-h4" data-money-convertible>' + formatMoney(newVariant['price'], window.theme.moneyFormat) + '</span>';
      }

      productMetaPrice.style.display = '';
    }
  }
}

function onVariantChanged(previousVariant, newVariant, element = document, currentProduct) {
  // 1st: the prices
  updateProductPrices(newVariant, previousVariant, element);

  // 2nd: SKU
  // newVariant.sku
  element.querySelector('.ProductMeta__SkuNumber').innerHTML = newVariant.sku;

  // 4th: update the price measurement
  updateUnitPrice(newVariant, element);

  // 5th: the add to cart button
  updateAddToCartButton(newVariant, element);

  // Finally, we send an event so that other system could hook and do their own logic
  element.dispatchEvent(new CustomEvent('variant:changed', {
    bubbles: true,
    detail: { variant: newVariant, product: currentProduct, previousVariant: previousVariant }
  }));
}

function getCurrentProductFromOptions() {
  var jsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
  var productData = jsonData['product'];

  return productData || null;
}


function getCurrentVariantFromOptions() {
  var jsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
  var productData = jsonData['product'];
  var _this6 = this;

  var found = false;

  productData['variants'].forEach(function (variant) {
    if (variant['option1'] === _this6.option1 && variant['option2'] === _this6.option2 && variant['option3'] === _this6.option3) {
      found = variant;
    }
  });

  return found || null;
}

function onOptionChanged(target, element) {
  var jsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
  var productData = jsonData['product'];
  var masterSelector = element.querySelector('#product-select-' + productData['id']);

  // We change the value associated with the activator, and check if we have a color swatch
  this['option' + target.getAttribute('data-option-position')] = target.value;
  var selectedValue = target.closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue');

  if (selectedValue) {
    selectedValue.innerHTML = target.value;
  }

  // Finally, we get the new variant
  previousVariant = currentVariant;
  currentVariant = getCurrentVariantFromOptions();
  currentProduct = getCurrentProductFromOptions();

  onVariantChanged(previousVariant, currentVariant, element, currentProduct);

  if (currentVariant) {
    // We need to modify the hidden select that contain the id attribute as well
    masterSelector.querySelector('[selected]').removeAttribute('selected');
    masterSelector.querySelector('[value="' + currentVariant['id'] + '"]').setAttribute('selected', 'selected');
  }
}

function attachListeners(element) {
  element.querySelector('[data-action="decrease-quantity"]').addEventListener('click', decreaseQuantity);
  element.querySelector('[data-action="increase-quantity"]').addEventListener('click', increaseQuantity);
  element.querySelector('[name="quantity"]').addEventListener('click', validateQuantity);

  var options = document.querySelectorAll('.ProductForm__Option [type="radio"]');
  for(var i=0; i<options.length; i++) {
    var option = options[i];
    option.addEventListener('change', (event) => {
      event.stopPropagation();
      onOptionChanged(event.target, element);
    });
  }
}

function lazyloadImage(img) {
  if (window.lazySizes && img) {
    lazySizes.loader.unveil(img);
  }
}

function reInitFlickity(elem = document) {
  var nodeList = elem.querySelectorAll('.Carousel');

  for (var i = 0, t = nodeList.length; i < t; i++) {
      var flkty = Flickity.data(nodeList[i]);
      if (!flkty) {
          // Check if element had flickity options specified in data attribute.
          var flktyData = nodeList[i].getAttribute('data-flickity-config');
          if (flktyData) {
            var flktyOptions = JSON.parse(flktyData);
            flickityInstance = new Flickity(nodeList[i], flktyOptions);
          } else {
            flickityInstance = new Flickity(nodeList[i]);
          }
      }
  }
}

function renderQuickShopView (fetchProductDetailUrl) {
  var quickShopDetail = document.querySelector('#quick-shop-content');

  let quickShopHTML = '';
  // fetch the product card html for each product
  fetch(fetchProductDetailUrl)
    .then((response) => {
      if (!response.ok) {
        return false;
      }
      return response.text();
    })
    .then((productDetail) => {
      if (!productDetail.length) return false;
      quickShopHTML = productDetail;

      // add html to the products container
      quickShopDetail.innerHTML = quickShopHTML;

      quickShopDetail.querySelector('.ProductForm').addEventListener('submit', addToCart);

      var jsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
      var productData = jsonData['product'];

      productData['variants'].forEach(function (variant) {
        if (variant['id'] === jsonData['selected_variant_id']) {
          currentProduct = jsonData['product'];
          currentVariant = variant;
          option1 = variant['option1'];
          option2 = variant['option2'];
          option3 = variant['option3'];
        }
      });

      attachListeners(quickShopDetail);
      quantitySelectorWithUnit();
      reInitFlickity(quickShopDetail);
    })
}

function scrolldown(event) {
  event.stopPropagation();
  event.preventDefault();
  var elemSelector = event.target.getAttribute("href");
  var scrollToElement = document.querySelector(elemSelector);

  const y = scrollToElement.getBoundingClientRect().top + window.scrollY - 220;
  window.scroll({
    top: y,
    behavior: 'smooth'
  });
}

function toggleFilter(event) {
  setTimeout(function(){
    var filterContainer = event.target.closest('.Collapsible.Collapsible--padded');
    var hasSelected = filterContainer.querySelector('.is-selected');
    var selectedIndicator = filterContainer.querySelector('.has-filter');
  
    if(hasSelected) {
      selectedIndicator.style.display = "block";
    } else {
      selectedIndicator.style.display = "none";
    }
  }, 100);
}

function addClickEventListener () {
  var moreInfoButton = document.querySelector('[href="#product_information"]');
  var storeAvailabilityButton = document.querySelector('[href="#store_availabilty"]');
  var toggleTagButtons = document.querySelectorAll('[data-action="toggle-tag"]');
  
  if(toggleTagButtons) {
    for(var i = 0; i < toggleTagButtons.length; i++) {
      var toggleTagButton = toggleTagButtons[i];
      toggleTagButton.addEventListener('click', toggleFilter);
    }
  }
  if(moreInfoButton) {
    moreInfoButton.addEventListener('click', scrolldown, false);
  }
  if(storeAvailabilityButton) {
    storeAvailabilityButton.addEventListener('click', scrolldown, false);
  }
}

function initCollectionPage() {
  var filterContainer = document.querySelector('#collection-filter-drawer');
  if(filterContainer) {
    var activeFilters = filterContainer.querySelectorAll('.is-selected');
    var activeFilterAmount = activeFilters.length;
    var filterAmountConatiner = document.querySelector('#filter-indicator');
  
    if(activeFilterAmount > 0 ) {
      filterAmountConatiner.style.display = 'flex';
      document.querySelector('#filter-length').innerHTML = activeFilterAmount;
  
    } else {
      filterAmountConatiner.style.display = 'none';
    }

    for(var i = 0; i < activeFilterAmount; i++) {
        var selectedIndicator = activeFilters[i];
        var filterContainer = selectedIndicator.closest('.Collapsible.Collapsible--padded');
        var hasSelected = filterContainer.querySelector('.is-selected');
        var selectedIndicator = filterContainer.querySelector('.has-filter');
      
        if(hasSelected) {
          selectedIndicator.style.display = "block";
        } else {
          selectedIndicator.style.display = "none";
        }
    }
  }
}

function addItemToDatalayer(detail) {
  var variant = detail.variant;
  var product  = detail.product;
  var hostname = window.location.hostname;
  var productObj = {
    'id': variant.id,
    'name': variant.name,
    'brand': product.vendor,
    'price': (variant.price* 0.01).toFixed(2),
    'image': variant.featured_image.src,
    'url': hostname + '/products/' + product.handle + '?variant=' + variant.id
  }
  // Measure adding a product to a shopping cart by using an 'add' actionFieldObject
  // and a list of productFieldObjects.
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    'event': 'addToCart',
    'ecommerce': {
      'currencyCode': 'EUR',
      'add': {                                // 'add' actionFieldObject measures.
        'products': [productObj]
      }
    }
  });
}

document.addEventListener('product:added', function(event) {
  var detail = event.detail; // Get the variant that was added
  addItemToDatalayer(detail);
});

var colorSwatchRadios = document.querySelectorAll('.ColorSwatch__Radio');
for(var i=0; i<colorSwatchRadios.length; i++) {
  var radio = colorSwatchRadios[i];
  radio.addEventListener('change', function(event){
    var productCard = event.target.closest('.ProductItem');
    var quickShopButton = productCard.querySelector('.quick-view');
    var quickShopUrl = event.target.getAttribute('data-product-id');
    var productItemUrl = event.target.getAttribute('data-product-item-url');
    quickShopButton.setAttribute('data-product-id', quickShopUrl);

    let productItemHTML = '';
    // fetch the product card html for each product
    fetch(productItemUrl)
      .then((response) => {
        if (!response.ok) {
          return false;
        }
        return response.text();
      })
      .then((productDetail) => {
        productItemHTML = $.parseHTML(productDetail);
        
        productCard.querySelector('#variantPriceList').innerHTML = $(productItemHTML).find("#variantPriceList").html();
        // productCard.querySelector('#variantAvailability').innerHTML = $(productItemHTML).find('#variantAvailability').html();
        productCard.querySelector('#productButtonWrapper').innerHTML = $(productItemHTML).find('#productButtonWrapper').html();
        productCard.querySelector('#productDiscount').innerHTML = $(productItemHTML).find('#productDiscount').html();
      })
  })
}

document.addEventListener('scroll', function(e) {
  if(window.innerWidth < 641) {
    makeBuyButtonSticky();
  }
  // if(document.body.classList.contains('template-collection')) {
  //   var windowScroll = document.documentElement.scrollTop;
  //   var links = document.querySelectorAll('a');
  //   for(var i=0; i<links.length; i++) {
  //     var url = links[i].getAttribute('href');
  //     if(url) {
  //       var queryParam = url.match(/([&||?])scroll-y=([^&#]*)/);
  //       if(queryParam) {
  //         url = url.replace(queryParam[0],'');
  //       }
  //       if(url.includes("?")) {
  //         url = url + '&scroll-y=' + windowScroll;
  //       } else {
  //         url = url + '?scroll-y=' + windowScroll;
  //       }
  //     }
  //     links[i].setAttribute('href', url);
  //   }
  // }
});

function variantImagePicker() {
  var productForm = document.querySelector('.ProductForm');
  if (productForm) {
    var imageVariantPickers = document.querySelectorAll('.Product__SlideshowNavImage[data-variant-color]');
    if (imageVariantPickers.length > 0) {
      imageVariantPickers.forEach((element) => {
        element.addEventListener('click', (event) => {
          var pickedColor = event.target.getAttribute('data-variant-color');
          if (productForm.querySelector(`[value="${pickedColor}"]`)) {
            productForm.querySelector(`[value="${pickedColor}"]`).click();
          }
        })
      })
    }
  }
}

$(document).ready(function() {
  quantitySelectorWithUnit();
  updateMeterPriceInMiniCart();
  addClickEventListener();
  initCollectionPage();
  variantImagePicker();
  var announcementBar = document.querySelector('[data-section-type="announcement-bar"]');
  if (announcementBar) {
    reInitFlickity(announcementBar);
  }
  var colorSwatches = document.querySelectorAll('.ProductItem__ColorSwatchList');
  for(var i=0;i<colorSwatches.length;i++) {
    reInitFlickity(colorSwatches[i]);
  }
  if(typeof productPage !== 'undefined') {
    featuredMediaId = productPage.featured_media.id;
    var productFlickityInstance = Flickity.data('.Product__Slideshow');

    for (var i = 0; i < productFlickityInstance.cells.length; ++i) {
      var cellElement = productFlickityInstance.cells[i].element,
          mediaId = parseInt(cellElement.getAttribute('data-media-id'));

      if (mediaId === featuredMediaId) {
        var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        productFlickityInstance.select(i, false, !shouldAnimate);
      }
    }
    updateProductFeatures();
    updateAvailability();
  }
});

